module.exports = __webpack_public_path__ + "img/login_banner.0bdaabf1.jpg";